module.exports = __webpack_public_path__ + "img/cross-white.4fdf3f7f.svg";